export const environment = { 
  production: false,
  environment: "dev", 
  
  // chime:"http://localhost:3001/",  /
  chime:"https://dev-chime.cc.my-compass.io/",  
};
